import { clearStoredAttribution } from './attribution'

/** Cookies written by the consent-gated tags: Google Analytics/Ads, Meta Pixel, Clarity. */
export const TRACKING_COOKIE = /^(_ga|_gid|_gat)(_.*)?$|^_gcl_|^_fbp$|^_fbc$|^_clck$|^_clsk$/

/**
 * Domains to replay a cookie delete on: host-only, the exact host, and every
 * dot-prefixed parent suffix.
 */
export function cookieDomainCandidates(host: string): (string | null)[] {
  const parts = host.split('.')
  const domains: (string | null)[] = [null, host]
  for (let i = 1; i < parts.length - 1; i++) domains.push(`.${parts.slice(i).join('.')}`)
  return domains
}

/**
 * Best-effort removal of the tracking cookies and the stored attribution after a
 * withdrawal or rejection.
 *
 * A cookie can only be deleted by a Set-Cookie whose name, path AND domain match the
 * one that created it. GA, Meta and Clarity write on the registrable parent domain
 * (`.example.com`), so the naive `path=/` + no-domain delete that most snippets use
 * silently does nothing on a www host. We therefore replay the delete once per
 * candidate domain. Writes for a domain the browser considers out of scope are simply
 * ignored, so the extra attempts are harmless.
 *
 * Known limits (acceptable - the authoritative switch is Consent Mode, not this):
 * cookies scoped to a path other than `/` and HttpOnly cookies cannot be removed from
 * JavaScript. None of these vendors set either.
 */
export function clearTrackingCookies() {
  clearStoredAttribution()

  const names = document.cookie
    .split(';')
    .map(pair => pair.split('=')[0]?.trim() ?? '')
    .filter(name => name && TRACKING_COOKIE.test(name))

  if (!names.length) return

  const domains = cookieDomainCandidates(window.location.hostname)
  for (const name of new Set(names)) {
    for (const domain of domains) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
        + (domain ? `; domain=${domain}` : '')
    }
  }
}
